<div class="label__container">
  <span class="signaturit-datepicker-label">{{label}}</span>
  <span class="signaturit-datepicker-label-required" *ngIf="required">{{'custom_circuit_custom_fields_required' |
    translate}}</span>
</div>
<div>
  <mat-form-field *ngIf="!range" class="signaturit-datepicker" appearance="outline">
    <input readonly (blur)="onBlur(this)" matInput [matDatepicker]="picker" [placeholder]="placeholder"
      [(ngModel)]="value" (dateChange)="inputChange(this)" [required]="required" (click)="picker.open()">
    <mat-datepicker-toggle class="icon" matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-error *ngIf="showError">
    {{'form_error_required' | translate}}
  </mat-error>
</div>
<div>
  <mat-form-field *ngIf="range" class="signaturit-datepicker" appearance="outline">
    <mat-date-range-input [rangePicker]="picker">
      <input readonly matStartDate [(ngModel)]="range1" placeholder="{{'terms_and_conditions.table_03' | translate}}"
        #dateRangeStart>
      <input (click)="picker.open()" (blur)="onBlurRange(this)" readonly matEndDate [(ngModel)]="range2"
        placeholder="{{'terms_and_conditions.table_04' | translate}}" #dateRangeEnd
        (dateChange)="dateRangeChange(this, range1, range2)">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix class="icon" [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
  <mat-error *ngIf="showErrorRange">
    {{'form_error_required' | translate}}
  </mat-error>
</div>
